import { render, staticRenderFns } from "./leaveContent.vue?vue&type=template&id=b7d52a9a&scoped=true"
import script from "./leaveContent.vue?vue&type=script&lang=js"
export * from "./leaveContent.vue?vue&type=script&lang=js"
import style0 from "./leaveContent.vue?vue&type=style&index=0&id=b7d52a9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d52a9a",
  null
  
)

export default component.exports